export default (fn, time) => {
  let timeout
  return function () {
    // eslint-disable-next-line no-invalid-this
    const functionCall = () => fn.apply(this, arguments)

    clearTimeout(timeout)
    timeout = setTimeout(functionCall, time)
  }
}
